import React, { useState, useEffect } from 'react';
import {
  Box,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  Divider,
  Typography,
  Button,
  ListItemText,
  Checkbox,
  Badge
} from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useSelector, useDispatch } from 'react-redux';
import { setMultipleQuestionTypes } from '../../../src/redux/slices/tableFilterSlice'; 
import { RootState } from 'src/redux/store';

const QuestionTypes = [
  'MULTIPLE_CHOICE',
  'TRUE_OR_FALSE',
  'FILL_IN_THE_BLANK',
  'MATCH_THE_FOLLOWING',
  'RANKING'
];

const QuestionFilter = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [localSelectedTypes, setLocalSelectedTypes] = useState<string[]>([]);
  const open = Boolean(anchorEl);

  const dispatch = useDispatch();
  const selectedTypes = useSelector((state: RootState) => state.question.multipleQuestionTypes);

  // Sync local state when menu is opened
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setLocalSelectedTypes(selectedTypes);
  };

  const handleClose = () => setAnchorEl(null);

  const handleToggle = (type: string) => {
    const updated = localSelectedTypes.includes(type)
      ? localSelectedTypes.filter((t) => t !== type)
      : [...localSelectedTypes, type];

    setLocalSelectedTypes(updated);
  };

  const handleClear = () => {
    setLocalSelectedTypes([]);
  handleClose()

  };

  const handleOk = () => {
    dispatch(setMultipleQuestionTypes(localSelectedTypes));
    handleClose();
  };

  return (
    <Box display="flex" gap={1}>
      <Badge badgeContent={selectedTypes.length || 0} color="primary">
        <IconButton
          onClick={handleClick}
          disableRipple
          disableFocusRipple
          sx={{ '&:hover': { backgroundColor: 'transparent' } }}
        >
          <FilterAltIcon fontSize="small" />
        </IconButton>
      </Badge>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleOk}
        PaperProps={{
          sx: {
            borderRadius: 2,
            minWidth: 250,
            boxShadow: 3,
            maxWidth: 200,
            maxHeight: 300,
            overflow: 'auto',
            padding: 0
          }
        }}
      >
        <Divider sx={{ mb: 1 }} />

        {QuestionTypes.length === 0 ? (
          <Typography variant="body2" sx={{ px: 2, py: 1, color: 'text.disabled' }}>
            No matching filters
          </Typography>
        ) : (
          QuestionTypes.map((type, idx) => (
            <MenuItem
              key={idx}
              onClick={() => handleToggle(type)}
              sx={{
                borderRadius: 1,
                width: '100%',
                py: 0.25,
                px: 0.75,
                minHeight: '28px',
                ':hover': { backgroundColor: '#f0f0f0' }
              }}
            >
              <Checkbox
                checked={localSelectedTypes.includes(type)}
                sx={{ p: 0.5 }}
              />
              <ListItemText
                primary={type}
                sx={{ wordBreak: 'break-word', whiteSpace: 'normal', fontSize: '0.75rem' }}
              />
            </MenuItem>
          ))
        )}

        <Divider sx={{ my: 1 }} />

        <Box display="flex" justifyContent="space-between" px={2} py={1}>
          <Button onClick={handleClear} sx={{ fontSize: '0.9rem', color: 'black' }}>
            Clear
          </Button>
        </Box>
      </Menu>
    </Box>
  );
};

export default QuestionFilter;
